import { HelpCircle, X, ShieldAlert, CheckCircle2 } from "lucide-react";

const PITCH_POINTS = [
  "National? Ask about media, gatekeeping, party primaries, or anything the mainstream keeps looking past.",
  "Big-picture? Science, politics, philosophy, religion — anything a party won't let you say the quiet part out loud on.",
  "Local case file? Georgia, Henry County, District 5 — send the zoning or officials worth spotlighting.",
  "Name and email are optional. Anonymous questions welcome.",
];

export const AskPitch = () => (
  <div className="lg:col-span-5">
    <div className="text-xs tracking-tight text-[var(--accent)] mb-3 flex items-center gap-2">
      <HelpCircle className="w-3.5 h-3.5" /> Ask A Question
    </div>
    <h3 className="font-display text-3xl md:text-5xl text-[#0A192F] leading-[1.05] tracking-tight">
      Got a question? <br />
      <span className="text-[var(--accent)]">Answer The F**king Question.</span>
    </h3>
    <p className="mt-6 text-base md:text-lg text-slate-700 leading-relaxed">
      Send a tip, a challenge, or a topic you want unpacked on-air. No gatekeeping, no
      press-release language — the sharpest questions get pulled into a segment.
    </p>
    <ul className="mt-6 space-y-3 text-sm text-slate-600">
      {PITCH_POINTS.map((p) => (
        <li key={p} className="flex items-start gap-3">
          <span className="mt-2 w-1.5 h-1.5 bg-[var(--accent)] shrink-0" />
          {p}
        </li>
      ))}
    </ul>
  </div>
);

export const GuestChip = ({ guest, onClear }) => (
  <div
    data-testid="atfq-ask-guest-chip"
    className="flex items-center justify-between gap-3 border border-[var(--accent)] bg-[var(--accent)]/10 px-4 py-3 text-sm text-[#0A192F]"
  >
    <span>
      Question for <strong>{guest.name}</strong>
      {guest.role ? <span className="text-slate-600"> · {guest.role}</span> : null}
    </span>
    <button
      type="button"
      data-testid="atfq-ask-guest-clear"
      onClick={onClear}
      aria-label="Remove guest"
      className="text-slate-500 hover:text-[#0A192F]"
    >
      <X className="w-4 h-4" />
    </button>
  </div>
);

export const AskError = ({ message }) => (
  <div
    role="alert"
    data-testid="atfq-ask-error"
    className="flex items-start gap-3 border border-red-300 bg-red-50 p-4 text-sm text-red-700"
  >
    <ShieldAlert className="w-4 h-4 mt-0.5 shrink-0" />
    <span>{message}</span>
  </div>
);

export const AskSuccess = ({ message }) => (
  <div
    role="status"
    data-testid="atfq-ask-success"
    className="flex items-start gap-3 border border-[var(--accent)]/50 bg-[var(--accent)]/10 p-4 text-sm text-[#0A192F]"
  >
    <CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0 text-[var(--accent)]" />
    <span>{message}</span>
  </div>
);
